import { on } from '@disy/lib/event-util';

export function setupKeyboardClick() {
  const delegate = '.keyboard-click';
  on(document, 'keydown', forwardToClick('Enter'), { delegate, capture: true });
  on(document, 'keyup', forwardToClick(' '), { delegate, capture: true });

  function forwardToClick(key: string) {
    return (event: KeyboardEvent) => {
      if (event.key === key) {
        const target = event.target as HTMLElement;
        const clickTarget = getKeyboardClickableActiveDescendant(target) ?? target;
        event.stopPropagation();
        event.preventDefault();
        clickTarget.click();
      }
    };
  }

  function getKeyboardClickableActiveDescendant(target: HTMLElement) {
    const activeDescendantId = target.getAttribute('aria-activedescendant');
    if (activeDescendantId) {
      const activeDescendant = document.getElementById(activeDescendantId);
      if (activeDescendant?.classList.contains('keyboard-click')) {
        return activeDescendant;
      }
    }
  }
}
